// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NDKnn","list":"styles_list__2HO_z","disableSelection":"styles_disableSelection__2DSQ6"};